import { type AppRouter } from './routers';
import { createTRPCProxyClient, httpLink } from '@trpc/client';

export const getClient = (url: string) =>
  createTRPCProxyClient<AppRouter>({
    links: [httpLink({ url })],
  });
